// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (!optionsListValueSelected(fields.futur_survivors_protection_beneficiary)) {
		return false;
	}

	if (fields.futur_survivors_protection_beneficiary.options[5].checked &&
		fields.futur_survivors_protection_beneficiary_other.length <= 0) {
		return false;
	}

	if (!optionsListValueSelected(fields.futur_survivors_protection_private_property)) {
		return false;
	}

	return true;
}

function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/SurvivorsProtection/SurvivorsProtection.fulfillment.js